import styled from 'styled-components';

import { CircleAddIcon } from '@treams/treams-icons';
import { tokens } from '@treams/treams-ui';

const SetGoalsBlockIconWrapper = styled.div`
	width: 24px;
	height: 24px;

	svg {
		width: 24px;
		height: 24px;
	}

	* {
		fill: ${tokens.text.secondary} !important;
	}
`;

function SetGoalsBlockIcon() {
	return (
		<SetGoalsBlockIconWrapper>
			<CircleAddIcon />
		</SetGoalsBlockIconWrapper>
	);
}

export default SetGoalsBlockIcon;
